<template>
  <div class="wrap">
    <!-- 微信认证组件 -->
    <wxAuth v-if="share" :share="share"></wxAuth>
    <headers :params="hraderP" />
    <van-form class="form" ref="formData" @submit="subMit">
      <van-field
        v-model="form.projectName"
        required
        clearable
        label="项目名称"
        placeholder="请输入名称"
        maxlength="30"
        :show-error-message="false"
        :rules="[{ required: true, message: '' }]"
      />
      <van-field
        v-model="form.projectRegistrant"
        required
        clearable
        maxlength="30"
        label="联系人"
        placeholder="请输入联系人"
        :show-error-message="false"
        :rules="[{ required: true, message: '' }]"
      />
      <van-field
        v-model="form.mobileTel"
        required
        clearable
        type="number"
        label="电话"
        maxlength="11"
        placeholder="请输入电话号码"
        :show-error-message="false"
        :rules="[{ validator, message: '' }]"
      />
      <van-field
        @click="showPC = true"
        v-model="procity"
        clearable
        readonly
        right-icon="arrow"
        label="项目地址"
        placeholder="请输入项目地址"
      />
      <van-field
        @click="showZB = true"
        v-model="form.biddingMethod"
        clearable
        right-icon="arrow"
        label="招标方式"
        placeholder="请选择你的招标方式"
        readonly
      />
      <van-field
        v-model="projectStage"
        @click="showJD = true"
        required
        readonly
        right-icon="arrow"
        label="项目阶段"
        placeholder="投标阶段"
        :show-error-message="false"
        :rules="[{ required: true, message: '' }]"
      />
      <van-field
        v-model="form.projectSystem"
        clearable
        label="项目系统"
        placeholder="请输入项目系统"
        maxlength="30"
      />
      <van-field
        v-model="form.projectBrand"
        clearable
        label="项目品牌"
        placeholder="请输入项目品牌"
        maxlength="30"
      />
      <van-field readonly label="其他说明" placeholder="备注" />
      <van-field
        class="textarea"
        v-model="form.remark"
        rows="3"
        type="textarea"
        maxlength="100"
        placeholder="请输入备注"
        show-word-limit
      />
    </van-form>
    <div class="flex-row">
      <div @click="reset">取消</div>
      <div @click="printFormValue">提交</div>
    </div>
    <!-- 选择地址 -->
    <van-popup v-model="showPC" round position="bottom">
      <van-picker
        @change="onCityChange"
        show-toolbar
        :columns="column"
        @cancel="showPC = false"
        @confirm="onPcConfirm"
      />
    </van-popup>
    <!-- 选择招标方式 -->
    <van-popup v-model="showZB" round position="bottom">
      <van-picker
        show-toolbar
        :columns="Bidding"
        @cancel="showZB = false"
        @confirm="onZbConfirm"
      />
    </van-popup>
    <!-- 项目阶段 -->
    <van-popup v-model="showJD" round position="bottom">
      <van-picker
        show-toolbar
        :columns="projectPhase"
        @cancel="showJD = false"
        @confirm="onJDConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
// 获得省市的
import { queryProvince } from '@/api/demands/demand'
// 项目登记表
import { addProRegistration } from '@/api/brand/brands'
import headers from '@/components/headers'
import { toLogin, isMobile } from '@/utils/common'
import wxAuth from '@/components/wxAuth'
export default {
  data () {
    return {
      share: {
        title: '解决方案馆',
        desc: '智能化产品方案,产品方案,系统方案,弱电设备方案,厂商方案,产品供应商设计方案,弱电设计方案,热门方案,规划设计方案,顶层设计方案,系统解决方案,集成商方案,招标方案,投标方案,深化设计方案,施工方案',
        imgUrl: 'https://image01.homedo.com/Files/Images/cms/www/20171225/4970465306687879653_pic1.jpg',
        url: window.location.href.split('#')[0]
      },
      hraderP: {
        title: '项目登记表',
        lefticon: true
      },
      form: {},
      //   展示城市
      showPC: false,
      //   招标方式
      showZB: false,
      //    项目阶段
      showJD: false,
      column: [],
      procity: '',
      projectStage: '',
      // 项目阶段
      projectPhase: [
        {
          id: 1,
          text: '规划阶段'
        },
        {
          id: 2,
          text: '投标阶段'
        },
        {
          id: 3,
          text: '深化阶段'
        }
      ],
      // 招标方式
      Bidding: ['公开招标', '邀标'],
      userInfo: {}
    }
  },
  components: {
    headers,
    wxAuth
  },
  async mounted () {
    await this.queryProvince(0)
    if (!isMobile()) {
      console.log(`${process.env.PC_SOLUTION_URL || '//solution.homedo.com'}/design/partner.html`)
      window.location.href = `${process.env.PC_SOLUTION_URL || '//solution.homedo.com'}/design/partner.html`
    }
    this.getUserInfo().then((res) => {
      this.userInfo = res
    })
  },
  methods: {
    async getUserInfo () {
      return new Promise((resolve, reject) => {
        $HMD$.GetLogin(function (data) {
          resolve(data)
        })
      })
    },
    // 校验手机号
    validator (val) {
      return /1\d{10}/.test(val)
    },
    async queryProvince (number) {
      queryProvince(number).then((res) => {
        let { status, data } = res
        if (status == 200) {
          let { code } = data
          if (code == 200) {
            const provinceData = {
              defaultIndex: 0,
              values: data.data.areas.map((item, index) => {
                return {
                  text: item.name,
                  value: item.id,
                  index: index
                }
              })
            }
            this.$set(this.column, 0, provinceData)
            this.getcity(1)
          }
        } else {
          this.$message.error()
        }
      })
    },
    // 获取城市
    getcity (number) {
      queryProvince(number).then((res) => {
        let { status, data } = res
        if (status == 200) {
          let { code } = data
          if (code == 200) {
            const cityData = {
              defaultIndex: 0,
              values: data.data.areas.map((item, index) => {
                return {
                  text: item.name,
                  value: item.id,
                  index: index
                }
              })
            }
            this.$set(this.column, 1, cityData)
          }
        }
      })
    },
    onCityChange (a, b, value) {
      if (value > 0) {
        return
      }
      this.getcity(b[value].value)
    },
    // 监听地址发生变化
    onPcConfirm (value) {
      this.form.cityCode = value[1].value
      this.form.cityName = value[1].text
      this.form.provinceCode = value[0].value
      this.form.provinceName = value[0].text
      this.procity = this.form.provinceName + '-' + this.form.cityName
      this.showPC = false
    },
    // 监听招标发生变化
    onZbConfirm (value) {
      this.form.biddingMethod = value
      this.showZB = false
    },
    onJDConfirm (value) {
      this.projectStage = value.text
      this.showJD = false
      this.form.projectStage = value.id
      console.log(this.form.projectStage)
    },
    printFormValue () {
      this.$refs.formData.submit()
    },
    subMit () {
      this.form.ownerId = this.userInfo.AccountId
      this.form.ownerName = this.userInfo.AccountName
      this.form.createBy = this.userInfo.AccountId
      this.form.createName = this.userInfo.AccountName
      if (!this.form.createBy) {
        toLogin()
      }
      addProRegistration(this.form).then((res) => {
        let { status, data } = res
        if (status == 200) {
          let { code } = data
          if (code == 200) {
            this.$toast.success('提交成功')
            setTimeout(() => {
              this.$router.push('/activity/dsg/rAndI.html')
            }, 300)
          } else {
            this.$toast.fail('请填写必填数据 再次提交')
          }
        }
      })
    },
    reset () {
      this.$router.push('/activity/dsg/rAndI.html')
    }
  }
}
</script>

<style scoped>
.wrap {
  height: 100%;
  background: #fff;
}
.form {
  padding: 0px 10px;
}
.textarea {
  width: 319px;
  height: 118px;
  background: #f8f9fb;
  margin: 12px auto;
  margin-top: -2px;
}
>>> .van-cell:nth-last-child(2)::after {
  border-bottom: none !important;
}
.flex-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  background: #fff;
  height: 100px;
}
.flex-row div {
  width: 142px;
  height: 44px;
}
.flex-row div:nth-child(1) {
  background: rgba(202, 202, 202, 1);
  color: #fff;
  font-size: 16px;
  line-height: 44px;
  text-align: center;
  border-radius: 22px;
}
.flex-row div:nth-child(2) {
  background: rgba(46, 123, 255, 1);
  color: #fff;
  font-size: 16px;
  line-height: 44px;
  text-align: center;
  border-radius: 22px;
}
</style>



// WEBPACK FOOTER //
// src/view/activities/designer/projectRegistration.vue